export const templates = Object.freeze({
  //statements
  RPT_SVR_STATEMENT_TEMPLATE: "P~xXH_t",
  RPT_SVR_PRICING_STATEMENT_TEMPLATE: "cW6W9US",
  //Orders
  RPT_SVR_CUST_ORD_TEMPLATE: "7nlkUi_3T",
  RPT_SVR_OFFI_ORD_TEMPLATE: "zP_Cumg",
  RPT_SVR_ORD_SUMXLS_TEMPLATE: "CtPfP8uHL",
  RPT_SVR_DETPDF_TEMPLATE: "wxDssq0",
  RPT_SVR_SUMPDF_TEMPLATE: "wMLa1TI",
  RPT_SVR_DETXLS_TEMPLATE: "fGPXWZAMZ",
  RPT_SVR_SUMXLS_TEMPLATE: "LSOiGM1",
  RPT_SVR_ORDHEAD_TEMPLATE: "rcGH4r0VMj",
  RPT_SVR_OFF_TEMPLATE: "DAU8HhoTu", //officer-----
  RPT_SVR_SER_DET_TEMPLATE: "Ddbxe1u", //service
  RPT_SVR_SER_EXC_TEMPLATE: "LeTSYVj", //service
  RPT_SVR_PDF_TEMPLATE: "RwPJvMl", //service summary
  RPT_SVR_EXC_TEMPLATE: "hH5G06AZx", // asset/crm reports
  RPT_SVR_AST_HED_TEMPLATE: "b0oeTjk",
  RPT_SVR_AST_DET_TEMPLATE: "x2AVZW3",
  // extended asset/crm reports
  RPT_SVR_CRM_TEMPLATE: "HO2apDD",
  // customer report
  RPT_SVR_CUS_DET_TEMPLATE: "iE3nmxB1hr",
  // master item
  RPT_SVR_MAS_DET_TEMPLATE: "a1t5tEvTCI",

  //inventory report
  RPT_SVR_INVEN_TEMPLATE: "RrpalrLEz",
  RPT_SVR_INVENDET_TEMPLATE: "D6hXK1Nqy",

  ////Statements//////
  RPT_SVR_FULFIL_STATEMENT1_TEMPLATE: "cS58GVS",
  RPT_SVR_FULFIL_STATEMENT2_TEMPLATE: "0h4Gswo",
  RPT_SVR_INVOICE_STATEMENT_TEMPLATE: "9eVjSVg",

  RPT_SVR_BULK_STATEMENTS_TEMPLATE: "qIzX4rEvm",

  //CRM Activity Summary Report Excel

  RPT_SVR_CRMORD_SUMXLS_TEMPLATE: "bcMukKU3r",

  ///New Asset Reports
  RPT_SVR_ASSLISXLS_TEMPLATE: "UJu-sL7Lq",
  RPT_SVR_ASSSERNEW_TEMPLATE: "OXtYKQsuj",
  RPT_SVR_ASSSERNEWPDF_TEMPLATE: "RzpV9AJvq",

  ////inventory usage
  RPT_INVENTORY_USAGE_TEMPLATE: "twQ3zFWDh",
});

export const STATEMENT_TYPES = Object.freeze([
  "invoice-statement",
  "fulfilment-note-two",
  "fulfilment-note-one",
]);
